import React from "react";
import "./App.css";
import { Routes, Route, Navigate } from "react-router-dom";
import Navbar from "./components/Navbar/Navbar"; // Uncomment and use if you have a React Navbar component
import Footer from "./components/Footer/Footer";
import Introduction from "./components/Introduction/Introduction";
import ShareButtons from "./components/SpeedDial/SpeedDial";
import Banner from "./components/Banner/Banner";
import CustomerPortal from "./pages/CustomerPortal"; // Import the CustomerPortal component
import Login from "./pages/Login"; // Import the Login component
import AdminOrders from "./pages/AdminOrders"; // Import the AdminOrders component
import CheckoutForm from "./pages/Checkout";
import Signup from "./pages/Signup"; // Import the Signup component
import CustomerProfile from "./pages/CustomerProfile";
import OrderSuccess from "./pages/OrderSuccess";
import HomePage from "./pages/HomePage";
import ContactPage from "./pages/ContactPage";
import ArtServicesTemp from "./pages/ArtServicesTemp";
import ArtServices from "./pages/ArtServices";
import RouteAnalytics from "./components/RouteAnalytics";
import DesignStudioPage from "./pages/DesignStudioPage";
import VerifyEmail from "./pages/VerifyEmail";
import FreshBooksOAuthCallback from "./pages/FreshBooksOAuthCallback";

function App() {
  return (
    <div className="App">
      <Navbar />
      <main className="App-content">
        <RouteAnalytics />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/dtf-sheet-builder" element={<CustomerPortal />} />
          <Route path="/login" element={<Login />} />
          <Route path="/admin" element={<AdminOrders />} />
          <Route path="/checkout" element={<CheckoutForm />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="*" element={<h1>404 Not Found</h1>} />
          <Route path="/profile/*" element={<CustomerProfile />} />
          <Route
            path="/oauth/callback"
            element={<FreshBooksOAuthCallback />}
          />
          <Route path="/completed/:orderid" element={<OrderSuccess />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/art-services" element={<ArtServices />} />
          <Route path="/design-studio" element={<DesignStudioPage />} />
          <Route
            path="/orders"
            element={<Navigate to="/profile/orders" replace />}
          />
          <Route path="/verify-email" element={<VerifyEmail />} />
        </Routes>
      </main>
      <Footer class="footer" />
    </div>
  );
}

export default App;
